import React from 'react';
import { Menubar } from 'primereact/menubar';
import { useNavigate, useLocation } from 'react-router-dom';
import { storage } from '../../helpers/storage';

const MenuTabletsDirector = ({ link }) => {

    const navigate = useNavigate();
    const location = useLocation();
    const cicloSel = storage.get('ciclo');

     //console.log('cicloSel', cicloSel.IdCicloEscolar)

    const nestedMenuitems = [
        {
            label: 'Personal',
            icon: 'pi pi-users',
            visible: parseInt(process.env.REACT_APP_SISTEMA) !== 1 ? true : false,
            command: e => {
                navigate('/entrega-personal');
            }
        },

        cicloSel != null && cicloSel.IdCicloEscolar >= 6 && {
            label: 'Gestión evidencias',
            icon: 'pi pi-book',
            style: {
                textShadow: location.pathname === '/maquila' && '0 0 red',
                color: location.pathname === '/maquila' && '#9b2f3e !important',
                fontWeight: location.pathname === '/maquila' && '500',
                textDecorationColor: location.pathname === '/maquila' && '#9b2f3e'

            },
            command: e => {
                navigate('/maquila');
            }
        },
        
        cicloSel != null && cicloSel.IdCicloEscolar < 6 && {
            label: 'Gestión evidencias', //"Evidencias" antes
            icon: 'pi pi-file',
            style: {
                textShadow: location.pathname === '/archivos' && '0 0 red',
                color: location.pathname === '/archivos' && '#9b2f3e !important',
                fontWeight: location.pathname === '/archivos' && '500',
                textDecorationColor: location.pathname === '/archivos' && '#9b2f3e'
            },
            command: e => {
                navigate('/archivos');
            }
        } 

        // {
        //     label: 'Pendientes',
        //     icon: 'pi pi-inbox',
        //     command: e => {
        //         if (parseInt(process.env.REACT_APP_SISTEMA) !== 1) {
        //             navigate('/pendientes-alumno');
        //         } else {
        //             navigate('/pendientes');
        //         }
        //     }
        // },
        //  {
        //     label: 'Reportes',
        //     icon: 'pi pi-fw pi-cog',
        //     items: [{
        //         label: 'General',
        //         icon: 'pi pi-fw pi-file-pdf',
        //         command: e => {
        //             navigate('/reporte-general');
        //         }
        //     }]
        // }
        // {
        //     label: 'Almacén',
        //     icon: 'pi pi-box',
        //     command: e => {
        //         navigate('/almacen/registro')
        //     }
        // }
    ];

    return (
        <div className="col-12" style={{ marginBottom: "15px" }}>
            <Menubar model={nestedMenuitems} className="surface-card"></Menubar>
        </div>
    );
}

export default MenuTabletsDirector;